import {STORE_CONTRACTOR_QUALIFICATION_REQUEST, STORE_CONTRACTOR_QUALIFICATION_SUCCESS, STORE_CONTRACTOR_QUALIFICATION_FAILURE} from '../actions';
import {UPDATE_CONTRACTOR_QUALIFICATION_REQUEST, UPDATE_CONTRACTOR_QUALIFICATION_SUCCESS, UPDATE_CONTRACTOR_QUALIFICATION_FAILURE} from '../actions';
import {
    QUALIFICATION_DOCUMENT_UPLOAD_REQUEST,
    QUALIFICATION_DOCUMENT_UPLOAD_SUCCESS,
    QUALIFICATION_DOCUMENT_UPLOAD_FAILURE,
    QUALIFICATION_DOCUMENT_DELETE_REQUEST,
    QUALIFICATION_DOCUMENT_DELETE_SUCCESS,
    QUALIFICATION_DOCUMENT_DELETE_FAILURE
} from '../actions';

export const CONTRACTOR_QUALIFICATION_INITIAL_STATE = {
    id: null,
    isFetching: false,
    error: null,
    name: '',
    start_date: '',
    end_date: '',
    isUploading: false,
    isRemoving: false,
    uploadError: null,
    removeError: null,
    documents: []
};

const qualificationReducer = {
    [STORE_CONTRACTOR_QUALIFICATION_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null, draft: true};
    },
    [STORE_CONTRACTOR_QUALIFICATION_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null}
    },
    [STORE_CONTRACTOR_QUALIFICATION_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [UPDATE_CONTRACTOR_QUALIFICATION_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null};
    },
    [UPDATE_CONTRACTOR_QUALIFICATION_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null}
    },
    [UPDATE_CONTRACTOR_QUALIFICATION_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [QUALIFICATION_DOCUMENT_UPLOAD_REQUEST]: (state) => {
        return {...state, isUploading: true, uploadError: null};
    },
    [QUALIFICATION_DOCUMENT_UPLOAD_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isUploading: false, uploadError: null};
    },
    [QUALIFICATION_DOCUMENT_UPLOAD_FAILURE]: (state, {error}) => {
        return {...state, isUploading: false, uploadError: error};
    },
    [QUALIFICATION_DOCUMENT_DELETE_REQUEST]: (state) => {
        return {...state, isRemoving: true, removeError: null};
    },
    [QUALIFICATION_DOCUMENT_DELETE_SUCCESS]: (state, {docId}) => {
        const documents = [...state.documents].filter(doc => doc.id !== docId);
        return {...state, documents, isRemoving: false, removeError: null}
    },
    [QUALIFICATION_DOCUMENT_DELETE_FAILURE]: (state, {error}) => {
        return {...state, isRemoving: false, removeError: error};
    }
};

export default function qualification(state = CONTRACTOR_QUALIFICATION_INITIAL_STATE, action) {
    let reducer = qualificationReducer[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/contractor-qualification.js